import { Action } from '@reduxjs/toolkit';

import { httpApiService, ServiceResponse } from 'app/api';

type RequestBody = {
  email: string;
};

// ---

export const OPEN_EMAIL_COLLECTOR_DIALOG  = 'EMAIL_COLLECTOR_DIALOG:OPEN';

export type OpenEmailCollectorDialog = Action<typeof OPEN_EMAIL_COLLECTOR_DIALOG>;

export const openEmailCollectorDialog = (): OpenEmailCollectorDialog => ({
  type: OPEN_EMAIL_COLLECTOR_DIALOG,
});

// ---

export const CLOSE_EMAIL_COLLECTOR_DIALOG  = 'EMAIL_COLLECTOR_DIALOG:CLOSE';

export type CloseEmailCollectorDialog = Action<typeof CLOSE_EMAIL_COLLECTOR_DIALOG>;

export const closeEmailCollectorDialog = (): CloseEmailCollectorDialog => ({
  type: CLOSE_EMAIL_COLLECTOR_DIALOG,
});

// ---

export type EmailCollectorActions = OpenEmailCollectorDialog | CloseEmailCollectorDialog;

// ---

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type DataFromBackend = any;

export const sendRequest = (
  url: string,
  data: RequestBody,
): ServiceResponse<DataFromBackend> => (
  httpApiService.post(url, data)
);
